<template>
    <b-container fluid >

    <div v-if="this.errorConexion == true" >
            <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
                <div class="row justify-content-center ">
                    <div class="col-sm-9 text-center mb-2">
                    <h1 class="style-nissan">Ha ocurrido un error de Conexión.</h1>
                    <p>Vuelve intentar mas tarde.</p>
                        <img src="../assets/error_conexion.png" class="img-fluid" width="250px" height="auto" alt="" />
                    <div>
                        <p>Puedes contactarnos a <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> 800-022-5425</p>
                    </div>
                    <div>
                        <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                    </div>
                    
                    <div v-if="this.cubeError == true" >
                        <p>Error Service autocomcube.</p>
                    </div>
                    <div v-if="this.latinError == true" >
                        <p>Error Service LainId.</p>
                    </div>
                    <div v-if="this.mailError == true" >
                        <p>Error Service mail.</p>
                    </div>
                    <div v-if="this.uuidError == true" >
                        <p>Error Service uuid.</p>
                    </div>
                    </div>
                </div>
            <template #overlay>
                <div class="text-center">
                <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
                <h6>Cargando ...</h6>
                </div>
            </template>
            </b-overlay>
    </div>

    <div v-if="this.errorConexion == false" id="inicio" class="row justify-content-md-center m-auto">

    <div class="col-sm-9 fondo">
        <b-card class="mt-4 details">
            <b-row v-if="this.typeP == 'U'" class="mb-4" >
                <div v-for="auto in autos" :key="auto.id" id="header" class="text-center">
                    <b-col class="txtF"><h6 class="txtF2">{{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS, {{formatPrice(auto.mileage)}} kms  </h6></b-col>
                </div>
            </b-row>

            <b-row v-if="this.typeP == 'N'" class="mb-4" >
                <div v-for="auto in autos" :key="auto.id" id="header" class="text-center">
                    <b-col class="txtF"><h6 class="txtF2">{{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS, 0 kms  </h6></b-col>
                </div>
            </b-row>
            <b-row>    
                <div class="col-md-2 text-center">
                <b-col class="txtF" >
                    Tiempo Suscripción
                    <h6 class="txtF2">{{this.tiempo}}</h6>
                </b-col>
                </div>
                <div class="col-md-2 text-center">
                <b-col class="txtF">
                    Costo Suscripción
                    <h6 class="txtF2">${{this.valorTotal}}</h6>
                </b-col>
                </div>
                <div class="col-md-3 text-center">
                <b-col class="txtF">
                    Suscripción Mensual
                    <h6 class="txtF2">${{this.valorTotal}}</h6>
                </b-col>
                </div>
                <div v-if="this.typeP == 'U'" class="col-md-3 text-center">
                <b-col class="txtF" >
                    Entidad Emplacamiento
                    <h6 class="txtF2">{{this.valorEntidad}}</h6>
                </b-col>
                </div>
                <div v-if="this.typeP == 'U'" class="col-md-2 text-center">
                <b-col class="txtF" >
                    Tipo Unidad
                    <h6 class="txtF2">Auto Seminuevo</h6>
                </b-col>
                </div>
                <div v-if="this.typeP == 'N'" class="col-md-3 text-center">
                <b-col class="txtF" >
                    Entidad Emplacamiento
                    <h6 class="txtF2">{{this.valorEntidad}}</h6>
                </b-col>
                </div>
                <div v-if="this.typeP == 'N'" class="col-md-2 text-center">
                <b-col class="txtF" >
                    Tipo Unidad
                    <h6 class="txtF2">Auto Nuevo</h6>
                </b-col>
                </div>
            </b-row>
        </b-card>


        <b-card border-variant="light" class="mt-3">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row >
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-1"  class="text-left espacio" label-for="input-1">
                        <h6>Nombre(s):</h6>
                    <b-form-input class="inputText" id="input-1" type="text" v-model="formaData.Nombre" placeholder="Nombre(s)"  maxlength="26" required autofocus></b-form-input>
                        <!-- <p>{{this.formaData.Nombre.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u")}}</p> -->
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-2" class="text-left espacio" label-for="input-3">
                        <h6>Primer Apellido:</h6>
                    <b-form-input class="inputText" id="input-2" v-model="formaData.ApellidoPaterno" placeholder="Primer Apellido" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left espacio" label-for="input-3">
                        <h6>Segundo Apellido:</h6>
                    <b-form-input class="inputText" id="input-3" v-model="formaData.ApellidoMaterno" placeholder="Segundo Apellido" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-10" class="text-left espacio" label-for="input-10">
                        <h6>Fecha de Nacimiento:</h6>
                        <b-form-input type="date"  v-model="formaData.FechaNacimiento" required ></b-form-input>
                        <b-form-text id="input-live-help" style="font-size:12px">Mayor de 18 años y menor de 70 años.</b-form-text>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-5" label-for="input-5" class="text-left espacio">
                        <h6>Correo electrónico:</h6>
                        <b-form-input id="input-5"  v-model="formaData.Email" type="email" placeholder="Ingresa tu email" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-6" class="text-left espacio" label-for="input-6">
                        <h6>Teléfono:</h6>
                    <b-form-input class="inputText" id="input-6"  v-model="formaData.Telefono" type="text" maxlength="10" required ></b-form-input>
                        <b-form-text id="input-live-help">Tu teléfono debe ser a 10 dígitos.</b-form-text>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-12" class="text-left espacio" label-for="input-12">
                        <h6>RFC:</h6>
                        <b-form-input id="idrfc" class="inputText" v-model="formaData.RFC" placeholder="RFC" maxlength="13" @change="upperRfc()" required pattern="[A-Z]{4}[0-9]{6}[A-Z0-9]{3}" title="Escribe tu RFC"></b-form-input>
                        <b-form-text id="input-live-help">Tu RFC debe ser a 13 dígitos.</b-form-text>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                    <b-col>
                        <b-form-group id="input-group-11" class="text-left espacio" label-for="input-11">
                            <h6>Régimen Fiscal:</h6>
                                <b-form-select id="input-11" v-model="formaData.TipoPersona" :options="regimen" class="mb-2 selectF" required></b-form-select>
                        </b-form-group>
                    </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-7" class="text-left espacio" label-for="input-7">
                        <h6>Código Postal:</h6>
                    <b-form-input id="input-7" class="inputText" v-model="formaData.Domicilio.CodigoPostal" placeholder="Código Postal" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-8" label-for="input-8" class="text-left espacio">
                        <h6>Estado:</h6>
                        <b-form-input id="input-8" class="inputText" v-model="formaData.Domicilio.Estado" placeholder="Estado" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>

                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-9" class="text-left espacio" label-for="input-9">
                        <h6>Ciudad:</h6>
                    <b-form-input id="input-9" class="inputText" type="text" v-model="Ciudad" placeholder="Ciudad" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-16" class="text-left espacio" label-for="input-16">
                        <h6>Colonia o Población:</h6>
                    <b-form-input id="input-16" class="inputText" v-model="formaData.Domicilio.Colonia" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-17" class="text-left espacio" label-for="input-17">
                        <h6>Delegación o Municipio:</h6>
                    <b-form-input id="input-17" class="inputText" v-model="formaData.Domicilio.Municipio" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-13" class="text-left espacio" label-for="input-13">
                        <h6>Calle:</h6>
                    <b-form-input id="input-13" class="inputText" v-model="formaData.Domicilio.Calle" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row>
                <div class="col-md-4">
                <b-col class="">
                    <b-form-group id="input-group-14" label-for="input-14" class="text-left espacio">
                        <h6>Número Exterior:</h6>
                        <b-form-input id="input-14" class="numerosExtInt" v-model="formaData.Domicilio.NumExterior" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col class="">
                    <b-form-group id="input-group-15" class="text-left espacio" label-for="input-15">
                        <h6>Número Interior:</h6>
                     <b-form-input id="input-15" class="numerosExtInt" v-model="formaData.Domicilio.NumInterior" type="text" maxlength="5" placeholder=""></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col class="mt-4">
                    <b-img src="../assets/important.png" style="width: 35px; height:auto;" alt=""></b-img> 
                    <span class="h6E"> Todos los campos son obligatorios.</span>
                </b-col>
                </div>
            </b-row>

            <b-row v-if="this.fechaNaIncorrecta == true" class="justify-content-md-center mt-3">
                <b-col cols="6">
                    <b-alert show variant="warning" dismissible><b>¡ Debes ser mayor de a 18 años ó menor a 69 años de edad !</b></b-alert>
                </b-col>
            </b-row>
            <b-row v-if="this.rfcIncorrecto == true" class="justify-content-md-center mt-3">
                <b-col cols="6">
                    <b-alert show variant="warning" dismissible><b>RFC Incorrecto</b></b-alert>
                </b-col>
            </b-row>
            <b-row v-if="this.telIncorrecto == true" class="justify-content-md-center mt-3">
                <b-col cols="6">
                    <b-alert show variant="warning" dismissible><b>Número de teléfono Incorrecto</b></b-alert>
                </b-col>
            </b-row>
            <b-row class="distancia">
                <div class="col-md-3">
                </div>
                <div class="col-md-4">
                <b-col>
                     <b-button type="submit" class="button_sc">SOLICITAR SUSCRIPCIÓN</b-button>
                     <!-- <b-button @click.prevent="cotizar()" class="button_sc">SOLICITAR SUSCRIPCION</b-button> -->
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                    <b-button @click.prevent="onReset()" class="button_ca">CANCELAR</b-button>
                </b-col>
                </div>
            </b-row>
            </b-form>
              <!-- <b-card class="mt-3" header="JSON">
                <pre class="m-0">{{ formaData }}</pre>
              </b-card> -->
        </b-card>
    </div>
    </div>
    </b-container>

</template>

<script>
import moment from 'moment';

  export default {
      name: "Formulario",

    data() {
      return {      
          autos: [],
          tipoUnidad: sessionStorage.getItem("tipoAutoP"),
          typeP: sessionStorage.getItem("typeUnidad"),
          FechaV: sessionStorage.getItem("fechaVigencia"),
          tags: sessionStorage.getItem("Tags"),
          costoSus: sessionStorage.getItem("valorTotal"),
          tiempo: sessionStorage.getItem("tiempoSuscripcion"),
          valorTotal: sessionStorage.getItem("valorSuscripcion"),
          valorEntidad: sessionStorage.getItem("emplacamiento"),
          kilometros: sessionStorage.getItem("kilometrosP"),
          deposito: 2400,
          fechaMail: '',
          diaActual: '',
          formaData: {
            Uuid: this.uuidv4(),
            Nombre: '',
            ApellidoPaterno: '',
            ApellidoMaterno: '',
            FechaNacimiento: '',
            Email: '',
            Telefono: '',
            RFC: '',
            TipoPersona: '',
            Tramite: 1,
            UnidadNegocio: 4,
            Agencia: 'Clickauto Mobility',
            Domicilio: {
                Calle: '',
                NumInterior: '',
                NumExterior: '',
                Colonia: '',
                CodigoPostal: '',
                Estado: '',
                Municipio: '',
            },
            Vehiculo: {
                Marca: '',
                Linea: '',
                Modelo: '',
                Version: '',
                Kilometraje: '',
                VIN: sessionStorage.getItem("vinUnidad"),
                NumeroSerie: '',
                Inventario: '',
                Year: '',
                Tipo_vehiculo: sessionStorage.getItem("TipoVehiculo"),
                Entidad_emplacamiento: sessionStorage.getItem("idemplacamiento"),
                Color: '',
                NIV: '',
                NoMotor: '',
                Precio_vehiculo: '',
                //Vigencia: '2022-03-01',
            },
            Suscripcion: {
                TipoSuscripcion: sessionStorage.getItem("TipoSuscripcion"),
                Vigencia: sessionStorage.getItem("fechaVigencia"),
                Modalidad: sessionStorage.getItem("modalidadNegocio"),
                Plazo: sessionStorage.getItem("PlazoSuscripcion"),
                Entrega: 1,
                FolioReserva: '',
                Cuota: sessionStorage.getItem("valorSuscripcion"),
            },
            Seguro: {
                Aseguradora: '',
                Precio_seguro: '',
                NoPoliza: '',
                TipoCobertura: ''
            }
          },
        Ciudad: '',
        kms: sessionStorage.getItem("kms"),
        dealerShip: sessionStorage.getItem("dealerShip"),
        show: true,
        regimen: [
          { value: 1, text: 'Persona Física' },
          { value: 2, text: 'Persona Física con Actividad Empresarial' },
          { value: 3, text: 'Persona Física Extranjera' }
        ],
        telIncorrecto: false,
        rfcIncorrecto: false,
        fechaNaIncorrecta: false,
        cubeError: false,
        latinError: false,
        mailError: false,
        uuidError: false,
        errorConexion: false,
        overlayI:false,
      }
    },

    methods: {

        iframeGoVirtual(){
            let message = { height: document.body.scrollHeight+50, width: document.body.scrollWidth }; 

            // window.top refers to parent window
            window.top.postMessage(message, "*");
            console.log('iFrame Go virtual -->',message);
        },

        onSubmit(event) {
            event.preventDefault();
            this.ValidadTelefono();
        },

        onReset(event) {
            window.history.go(-1);
        },

        clearTimeout() {
            if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
            }
        },

        setTimeout(callback) {
            this.clearTimeout()
            this.timeout = setTimeout(() => {
            this.clearTimeout()
            callback()
            }, 5000);
        },

        regresar(){
        window.history.go(-2);
        },

        ValidadTelefono() {
             if (this.formaData.Telefono.length == 10){
                    this.telIncorrecto = false;
                    let telefono = this.formaData.Telefono;
                    let validacion = /^[0-9]+$/;
                        if (telefono.match(validacion)){
                            this.telIncorrecto = false;
                            this.ValidaRfc();
                        } else {
                            this.telIncorrecto = true;
                        }
             }else{
                     this.telIncorrecto = true;
             }
        },
        ValidaRfc() {
            let strCorrecta;
            strCorrecta = this.formaData.RFC;	
            if (this.formaData.RFC.length == 13){
                const valid = '[A-Z]{4}[0-9]{6}[A-Z0-9]{3}';
                const validRfc=new RegExp(valid);
                const matchArray=strCorrecta.match(validRfc);
                if (matchArray==null) {
                    this.rfcIncorrecto = true;
                }
                else
                {
                    this.rfcIncorrecto = false;
                    this.validaEdad();
                }
            }else{
                    this.rfcIncorrecto = true;
            }
        },

        validaEdad(){
            const date = new Date();
            const fechaNacimiento  = new Date(this.formaData.FechaNacimiento);
            const anios = date.getFullYear() - fechaNacimiento.getFullYear();
            const actual = date.getFullYear();
            const anio = parseInt(this.formaData.FechaNacimiento.substr(0,4), 10);
            if(anio < 1940 || anio > actual ){
                this.fechaNaIncorrecta = true;
            }else if ( this.calculaEdad() >= 18 && this.calculaEdad() < 75){
                this.fechaNaIncorrecta = false;
                this.tokenLatin();
            } else {
                this.fechaNaIncorrecta = true;
            }
        },

        calculaEdad(){
            var nacimiento=moment(this.formaData.FechaNacimiento);
            var hoy=moment();
            var anios=hoy.diff(nacimiento,"years");
            return anios
        },

        cotizar(){
            this.enviaCreatio();
            this.enviaMail();
        },

        fechasMail(){
            const date = new Date();
            const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');

            const date2 = new Date().toString();
            const date3 = date2.substring(16,24)
            sessionStorage.setItem("fechaCreatio", output+'T'+date3+'-00:00');

            this.diaActual = output;
            const diaFinMes = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const mensaje = diaFinMes.toLocaleDateString("es-ES", options);
            this.fechaMail = mensaje;
            sessionStorage.setItem("fechaPromo", this.fechaMail);
            console.log('último dia -->', this.fechaMail + ' - ' + this.diaActual);
        },

        tokenMail(){
            let user = {username: "noreply@clikautomobility.com", password: "Desarrollo123$"};
            axios.post("https://srv-notificaciones.autocom.mx/api/token/login", user)
            .then((response) => {
            //console.log("token stock-->", response.data.token);
            sessionStorage.setItem("mailToken", response.data.token);
            }).catch(error => {
                this.errorConexion = true;
                this.cubeError = false;
                this.latinError = false;
                this.mailError = true;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Mail Token --> ',error);
            });
        },

        enviaCreatio(){
        let post = {
            desde:'soportedigital@clikauto.com',
            asunto:'Suscripción ClikAutoMobility '+this.rest,
            source:'Suscripción',
            status:sessionStorage.getItem("status"),
            interest:'Clikauto Mobility',
             solicitanteid: this.rest,
             fechaCreatio: sessionStorage.getItem("fechaCreatio"),
             anio: this.formaData.Vehiculo.Year,
             marca: this.formaData.Vehiculo.Marca,
             modelo: this.formaData.Vehiculo.Modelo,
             version: this.formaData.Vehiculo.Version,
             vin: this.formaData.Vehiculo.NumeroSerie,
             nombre: this.formaData.Nombre,
             paterno: this.formaData.ApellidoPaterno,
             materno: this.formaData.ApellidoMaterno,
             email: this.formaData.Email,
             telefono: this.formaData.Telefono,
             calle: this.formaData.Domicilio.Calle,
             ciudad: this.formaData.Domicilio.Estado,
             cpostal: this.formaData.Domicilio.CodigoPostal,
             comentarios: 'Tiempo Suscripción:'+this.tiempo+',Costo:'+this.formaData.Vehiculo.Cuota+',Entidad Emplacamiento:'+this.valorEntidad+',Tipo Unidad:'+sessionStorage.getItem("status")+',Ciudad:'+this.Ciudad+',Fecha Nacimiento:'+this.formaData.FechaNacimiento+',Régimen fiscal:'+this.formaData.TipoPersona+',RFC:'+this.formaData.RFC+',Núm exterior:'+this.formaData.Domicilio.NumExterior+',Colonia:'+this.formaData.Domicilio.Colonia+',Delegación / municipio:'+this.formaData.Domicilio.Municipio+',kilometraje:'+this.kms+',Nombre dealer:'+this.dealerShip+',Suscripción:'+sessionStorage.getItem("Tags"),
             urlDealer: 'www.clikautomobility.com',
             dealer: 'Clikauto Mobility'}
          axios.post('https://suscripciones.autocom.mx/api/sendCreatio', post).then(response =>{
          console.log(response.status);
          }).catch(error=>{
          console.log(error)
          })
        },
        enviaMail(){
        let mail = {
            user:"noreply@clikautomobility.com",
            aplication:"ClikAuto Mobility",
            subject:"Continúa aquí tu solicitud de suscripción",
            EmailsTo: [{email:this.formaData.Email}],
            EmailsToCc: [{emailCc:"soportedigital@clikauto.com"},
            {emailCc:"rosa.velia@autocom.mx"},
            {emailCc:"atencionmobility@clikautomobility.com"},
            {emailCc:"soportedigital@clikautomobility.com"}],
            body:`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta name="x-apple-disable-message-reformatting">

<title></title>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<style>

table, td, div, h1, p, h6 {
font-family: Arial, Helvetica, sans-serif;
}

h1 {
	font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 700;
font-size: 25px;
line-height: 150.1%;
color: #51555C;
}

p {
	font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 19px;
color:  #51555C;
}

.subt{
	font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 400;
font-size: 10px;
line-height: 150.1%;
}

.dato{
	font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 700;
font-size: 25px;
line-height: 150.1%;
}

.general{
	font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 400;
font-size: 15px;
line-height: 150.1%;
}

.small{
font-family: Arial, Helvetica, sans-serif;
font-style: normal;
font-weight: 400;
font-size: 10px;
line-height: 150.1%;
text-align: center;
color: #908B8D;
}

</style>
</head>
<body style="margin:0;padding:0; background-color: #E5E5E5;">
	<table align="center" role="presentation" style="width:600px;border-collapse:collapse;border:0;border-spacing:0;background:#ffffff;">
		<tr>
			<td align="center" style="padding:0;background-color: #1A2544; padding: 28px">

            <img src="https://qa-suscripciones.autocom.mx/img/clikautomobility_logo.f34456fd.png" alt="" width="300px" style="height:auto;display:block;" />
            </td>
            </tr>
			<tr style="padding:0px 30px;">
				<td style="padding:0px 30px">
					<table align="center" role="presentation" style="width:600px;border-collapse:collapse;border:0;border-spacing:0;background:#FFFFFF;padding:30px">
						<tr>
							<td>
								<h1 style="text-align: center;padding-top:10px; font-family: Arial, Helvetica, sans-serif !important;">
									¡Hola ${this.formaData.Nombre} ${this.formaData.ApellidoPaterno} ${this.formaData.ApellidoMaterno} tenemos tus resultados!
								</h1>
								<p style="text-align:center;font-weight: 400; font-size: 15px; line-height: 150.1%;padding: 0 15%">
									Solicitud de suscripción pre aprobada pendiente, continúa desde un dispositivo móvil.
								</p>
							</td>
						</tr>
						<tr>
							<td>
								<table align="center" style="background-color: #51555C;width: 540px;">
									<tr>
										<td>
											<p style="color:#FFFFFF;text-align:center;padding-bottom: 0px;line-height: 0px;padding-top: 10px;">
												${this.formaData.Vehiculo.Year}, ${this.formaData.Vehiculo.Marca} ${this.formaData.Vehiculo.Version}, ${this.formaData.Vehiculo.Modelo}, ${this.formatPrice(this.kilometros)} kms
											</p>

										</td>
									</tr>

                                <tr><td><table width="100%" style="padding-top:0px;padding-bottom:5px">

									<tr style="padding-top:0px">
										<td style="width:33%">
											<p style="font-weight: 400;font-size: 10px;text-align: center;color: #FFFFFF;line-height: 0px;">
												Fecha de Solicitud: ${this.diaActual}
											</p>
										</td>
										<td style="width:33%">
											<p style="font-weight: 400;font-size: 10px;text-align: center;color: #FFFFFF;line-height: 0px;">
												VIN: ${this.vin}
											</p>
										</td>
										<td style="width:33%">
											<p style="font-weight: 400;font-size: 10px;text-align: center;color: #FFFFFF;line-height: 0px;">
												Tipo: ${this.tipoUnidad}
											</p>
										</td>
									</tr>
                                </table></td></tr>

								</table>
							</td>
						</tr>
						<tr >
							<td style="padding-top:15px">
								<table align="center" style="background-color: #E6E6E6;width: 540px;">
									<tr>
										<td>
											<p class="subt" style="text-align:center;">
												Tiempo Suscripción
												<br>
												<span class="dato">${this.tiempo}
												</span>
											</p>

										</td>
										<td>
											<p class="subt"  style="text-align:center;">
												Suscripción Mensual<br>
												<span class="dato">$${this.valorTotal}
												</span>
											</p>

										</td>

                                        <td>
											<p class="subt"  style="text-align:center;">
												Entidad emplacamiento
												<br>
												<span class="dato">${this.valorEntidad}
												</span>
											</p>

										</td>

									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td>
						<table width="100%">
							<tr>
							<td>
								<p class="general" style="text-align: center;font-size: 10px;">Oferta válida al ${this.fechaMail} <br>Aplican restricciones
								</p>
							</td>
							</tr>
							<tr>
							<td>
								<p class="general" style="text-align: center; line-height: 5px;padding-bottom:10px">¡Termina ahora tu solicitud!
								</p>
							</td>
							</tr>
							<tr>
								<td>
									<p align="center" > 
                                    <a  style="text-decoration: none; padding: 10px; font-weight: 600; font: 700; font-size: 15px; padding: 15px 50px;background-color:#51AED3;border:0px;border-radius:15px;font-family:Open sans, sans-serif;font-weight:600;line-height:23px;color:white;" href="https://clikautofinance.creditcheck.mx:9445/MobilityWeb/#/resume/applicant/${sessionStorage.getItem("UUID58")}">CONTINUAR</a></p>
								</td>
							</tr>
							<tr>
							<td>

								</p>
								
								<p class="general" style="text-align: center;padding-top: 20px;"><img src="https://qa-suscripciones.autocom.mx/img/logo_clikautomobility.094a6318.png" width="200px"></p>
								<hr style="border: 0.4px solid #BDBDBD;">
								<p class="small" style="padding-bottom:25px">
								*Para dudas en tu proceso recuerda contactarnos en cualquier momento al teléfono: <b>800-022-5425</b>
                                 o vía correo electrónico en <b>atencion@clikautomobility.com</b> de Lunes a Viernes de 8 am a 8 pm o Sábado de 9 am a 5 pm.
								</p>
							</td>
							</tr>
						</table>
					</td>
				</tr>
					</table>
				</td>
			</tr>
	</table>
</body>
</html>
        `};

        axios.post("https://srv-notificaciones.autocom.mx/api/emailSend",mail, {
            headers: {
            Authorization: "Bearer " + sessionStorage.getItem("mailToken"),
            'Content-Type': 'application/json',
            }, 
            }).then((response) => {
                console.log('Mail --->', response.status);
                this.$router.push({ path: '/correo'});
            }).catch(error => {
                this.errorConexion = true;
                this.cubeError = false;
                this.latinError = false;
                this.mailError = true;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Enviar Mail 1 --> ',error);
            });
        },
    cargarInfoVehiculo(){
            this.type= sessionStorage.getItem("typeUnidad");
        if( this.type == 'U'){
            this.autosSeminuevos();
        } else if( this.type == 'N'){
            this.autosNuevos();
        }
      },
        autosSeminuevos(){
        this.vin= sessionStorage.getItem("vinUnidad");
        // console.log('Seminuevo');
            //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
            axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
            headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
            },
            params: {vin: this.vin,},
            })
            .then((response) => {
                this.formaData.Vehiculo.Marca = response.data.usedstock[0].brandDescription;
                this.formaData.Vehiculo.Linea = response.data.usedstock[0].brandDescription;
                this.formaData.Vehiculo.Inventario = response.data.usedstock[0].id;
                this.formaData.Vehiculo.Modelo = response.data.usedstock[0].trimDesciption;
                this.formaData.Vehiculo.Year = response.data.usedstock[0].modelYear;
                this.formaData.Vehiculo.Version = response.data.usedstock[0].modelDescription;
                this.formaData.Vehiculo.Kilometraje = response.data.usedstock[0].mileage;
                this.formaData.Vehiculo.Precio_vehiculo = response.data.usedstock[0].webPrice;
                this.formaData.Vehiculo.Color = response.data.usedstock[0].colourDescription;
                this.autos = response.data.usedstock;
            }).catch(error => {
                this.errorConexion = true;
                this.cubeError = true;
                this.latinError = false;
                this.mailError = false;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Inventario SemiNuevo --> ',error);
            });
        },

        autosNuevos(){
        this.vin= sessionStorage.getItem("vinUnidad");
        //console.log('Nuevos');
            //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
            axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
            headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
            },
            params: {vin: this.vin,},
            })
            .then((response) => {
                this.formaData.Vehiculo.Marca = response.data.newstock[0].brandDescription;
                this.formaData.Vehiculo.Linea = response.data.newstock[0].brandDescription;
                this.formaData.Vehiculo.Inventario = response.data.newstock[0].id;
                this.formaData.Vehiculo.Modelo = response.data.newstock[0].trimDesciption;
                this.formaData.Vehiculo.Year = response.data.newstock[0].modelYear;
                this.formaData.Vehiculo.Version = response.data.newstock[0].modelDescription;
                this.formaData.Vehiculo.Kilometraje = response.data.newstock[0].mileage;
                this.formaData.Vehiculo.Precio_vehiculo = response.data.newstock[0].webPrice;
                this.formaData.Vehiculo.Color = response.data.newstock[0].colourDescription;
                this.autos = response.data.newstock;
            }).catch(error => {
                this.errorConexion = true;
                this.cubeError = true;
                this.latinError = false;
                this.mailError = false;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Inventario Nuevos --> ',error);
            });         
        },

        uuidv4() {
            const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
            sessionStorage.setItem("uuidsus", uuid);
            return uuid;
        },

        upperRfc() {
          var x=document.getElementById("idrfc").value
          document.getElementById("idrfc").value=x.toUpperCase()
        },

        tokenLatin(){
            let TknLatin = {apikey: "5VC3jwvcPWWBbfJXHwezCEj116LoHEoJF"};
            // axios.post("https://autocom-dev.latinid-cloud.com.mx/API/GetToken", TknLatin)
            //axios.post("https://autocom-prod.latinid-cloud.com.mx/API/GetToken", TknLatin)
            //axios.post("https://clikautofinance.creditcheck.mx:9445/API/GetToken", TknLatin)
            axios.post("https://apis.latinid.com.mx:9581/API/GetToken", TknLatin)
            //axios.post("https://sandbox-clikautofinance.creditcheck.mx:9446/API/GetToken", TknLatin)
            .then((response) => {this.tokenLatin = response.data.token;
                sessionStorage.setItem("tknLatinSus", response.data.token);
                //console.log('Token Latin Id --> ',response.data.token);
                this.latinId();
            }).catch(error => {
                this.errorConexion = true;
                this.cubeError = false;
                this.latinError = true;
                this.mailError = false;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Token Latin Id --> ',error);
            });
        },

        latinId(){
            //    axios.post("https://autocom-dev.latinid-cloud.com.mx/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
               //axios.post("https://autocom-prod.latinid-cloud.com.mx/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
                //axios.post("https://clikautofinance.creditcheck.mx:9445/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
                axios.post("https://apis.latinid.com.mx:9581/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
                //axios.post("https://sandbox-clikautofinance.creditcheck.mx:9446/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
                   headers: {
                   Authorization: "Bearer " + sessionStorage.getItem("tknLatinSus"),
                   'Content-Type': 'application/json',
                   }
               }).then((response) => {this.rest = response.data.SolicitanteId;
               sessionStorage.setItem("SolicitanteID", this.rest);
               console.log('Solicitante-->', response);
               //console.log('ID session -->', sessionStorage.getItem("SolicitanteID"));              
               this.base58();
              }).catch(error => {
                this.errorConexion = true;
                this.cubeError = false;
                this.latinError = true;
                this.mailError = false;
                this.uuidError = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Latin Id --> ',error);
            });
        },

        base58(){
            this.rest;
            this.valor=+this.rest+`||`+sessionStorage.getItem("uuidsus");
            // console.log('Valor--->',this.valor);
             axios.get("https://financiamiento.autocom.mx/api/base58/"+this.valor).then((response) => {
             this.base58 = response.data;
            //  console.log("Base 58-->", this.base58);
             sessionStorage.setItem("UUID58", this.base58);
             this.cotizar();
             }).catch(error => {
                this.errorConexion = true;
                this.cubeError = false;
                this.latinError = false;
                this.mailError = false;
                this.uuidError = true;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Base 58 --> ',error);
            });
        },

        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

    },

  created() {
      this.fechasMail();
      this.cargarInfoVehiculo();
      this.tokenMail();
      this.iframeGoVirtual();
   },

     computed: {
      validaRfc1() {
        return this.formaData.RFC.length < 14 && this.formaData.RFC.length > 12 && this.formaData.RFC.length != '' ? true: false
      },

      validaTel() {
        return this.formaData.Telefono.length < 11 && this.formaData.Telefono.length > 9 && this.formaData.Telefono.length != '' ? true: false
      },

      validaCp() {
        return this.formaData.Domicilio.CodigoPostal.length < 6 && this.formaData.Domicilio.CodigoPostal.length > 4 && this.formaData.Domicilio.CodigoPostal.length != '' ? true: false
      },

      validaNombre() {
        return this.formaData.Nombre.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u");
      },

      validaApaterno() {
        return this.formaData.ApellidoPaterno.length < 27 && this.formaData.ApellidoPaterno.length > 0 && this.formaData.ApellidoPaterno.length != '' ? true: false
      },

      validaAmaterno() {
        return this.formaData.ApellidoMaterno.length < 27 && this.formaData.ApellidoMaterno.length > 0 && this.formaData.ApellidoMaterno.length != '' ? true: false
      },

      validaCalle() {
        return this.formaData.Domicilio.Calle.length < 41 && this.formaData.Domicilio.Calle.length > 0 && this.formaData.Domicilio.Calle.length != '' ? true: false
      },
      validaEstado() {
        return this.formaData.Domicilio.Estado.length < 41 && this.formaData.Domicilio.Estado.length > 0 && this.formaData.Domicilio.Estado.length != '' ? true: false
      },
      validaCiudad() {
        return this.Ciudad.length < 41 && this.Ciudad.length > 0 && this.Ciudad.length != '' ? true: false
      },
      validaMunicipio() {
        return this.formaData.Domicilio.Municipio.length < 41 && this.formaData.Domicilio.Municipio.length > 0 && this.formaData.Domicilio.Municipio.length != '' ? true: false
      },
      validaColonia() {
        return this.formaData.Domicilio.Colonia.length < 41 && this.formaData.Domicilio.Colonia.length > 0  && this.formaData.Domicilio.Colonia.length != '' ? true: false
      },
    }
  }
</script>

<style>

</style>